  <td-wb-modal-header [iconId]="iconId()">
    <td-wb-modal-header-title [modalTitle]="modalTitle()" />
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button />
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>
